module.exports = __webpack_public_path__ + "img/5.092b656f.png";